import React, { createContext, useContext, ReactNode } from 'react';
import { mockApiService, MockApiService } from '../services/MockApiService';

const ApiContext = createContext<MockApiService | undefined>(undefined);

export const ApiProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <ApiContext.Provider value={mockApiService}>
      {children}
    </ApiContext.Provider>
  );
};

export const useApi = () => {
  const context = useContext(ApiContext);
  if (context === undefined) {
    throw new Error('useApi must be used within an ApiProvider');
  }
  return context;
};